import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info-card-header',
  templateUrl: './info-card-header.component.html',
})
export class InfoCardHeaderComponent {
  @Input() iconClass: string = '';
  @Input() title: string = '';
  @Input() showCollapse: boolean = false;
  @Input() showStatus: boolean = false;
  @Input() statusIcon: string = '';
  @Input() statusColor: string = '';
  @Input() statusTitle: string = '';
}
